export default {"src":"/app/presentation/_next/static/media/frames.03114e48.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};